import React from "react";

import { Container } from "./styles";
import { WhatsappButton } from "../../assets/common";
import WhatsappIcon from "../../assets/common/icon-whatsapp.png";

interface IProps {
  photo: string;
  name: string;
  address: string;
  phone: string;
  criare?: boolean;
  italinea?: boolean;
  link?: string;
  onClick?: () => any;
}

const ContactProfile: React.FC<IProps> = ({
  photo,
  name,
  address,
  phone,
  criare,
  italinea,
  link,
  onClick
}) => {
  return (
    <Container criare={criare} italinea={italinea}>
      <div className="column1">
        <img src={photo} alt="" />
      </div>
      <div className="column2">
        <h3 className="name">{name}</h3>
        <span className="address">{address}</span>
        {phone && (
          <>
            <span className="phone">{phone}</span>
            <a href={link} onClick={onClick}>
              <button className="btn-whatsapp">
                <img src={WhatsappIcon} alt="" />
                Iniciar Atendimento
              </button>
            </a>
          </>
        )}
      </div>
    </Container>
  );
};

export default ContactProfile;
